import React, {ChangeEvent} from 'react';
import {Choice, FieldProp} from '../../types';

type RadioButtonsProps = FieldProp & {};

export const RadioButtons: React.FunctionComponent<RadioButtonsProps> = ({
                                                                             field,
                                                                             fieldState,
                                                                             value = [],
                                                                             displayOnly,
                                                                             onChange,
                                                                             onBlur,
                                                                         }
): JSX.Element => {
    const {touched, pristine, valid, invalid, errors} = fieldState;

    const iconMap = field?.flowCustomDisplayComponentConfig?.icons || {};
    const valueHoverClassMap = field?.flowCustomDisplayComponentConfig?.hoverClasses || {};
    const valueSelectedClassMap = field?.flowCustomDisplayComponentConfig?.selectedClasses || {};
    const displayOnlyMode = field?.flowCustomDisplayComponentConfig?.displayOnlyMode || 'default';

    const classNames = [
        'form-check-input',
        touched && 'is-touched',
        pristine && 'is-pristine',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    const containerClasses = [
        'radio-buttons',
        'd-flex align-items-stretch pt-2'
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <>
            <div className={containerClasses}>
                {field.choices &&
                    field.choices
                        .filter((choice: Choice) => (
                            !displayOnly ||
                            (
                                displayOnly &&
                                (
                                    displayOnlyMode === 'default' ||
                                    (
                                        displayOnlyMode === 'selected-value-only' &&
                                        (
                                            !value?.value ||
                                            (value && value.value === choice.value)
                                        )
                                    )
                                )
                            )
                        ))
                        .map((choice: Choice, index: number) => {
                    const isChecked = (value && value.value === choice.value);
                    const displayClasses = [
                        'd-block border pt-1 pb-1 pl-2 pr-2 h-100',
                        'align-items-stretch',
                        isChecked && 'bg-secondary text-white border-dark',
                        !isChecked && 'bg-light text-dark border-secondary',
                        isChecked && valueSelectedClassMap.hasOwnProperty(choice.value) && valueSelectedClassMap[choice.value]
                    ]
                        .filter(Boolean)
                        .join(' ');
                    const labelClasses = [
                        'radio-buttons',
                        'btn btn-sm',
                        isChecked && 'btn-secondary border border-secondary',
                        !isChecked && 'btn-light border border-secondary',
                        isChecked && valueSelectedClassMap.hasOwnProperty(choice.value) && valueSelectedClassMap[choice.value]
                    ]
                        .filter(Boolean)
                        .join(' ');

                    return (
                        <div key={`${field.id}-${index}`}
                             className="mr-1">
                            {displayOnly ?
                                <div className={displayClasses} style={{whiteSpace: 'nowrap'}}>
                                    {/* JDM TODO - DELETE ABOVE STYLE ATTrIBUTE AND MAKE CONFIG */}
                                    {choice.text}
                                    {iconMap.hasOwnProperty(choice.value) && <i className={iconMap[choice.value]} />}
                                </div>
                                :
                                <label className={labelClasses} htmlFor={`${field.id}-${index}`}>
                                    <input
                                        id={`${field.id}-${index}`}
                                        className={classNames}
                                        type="radio"
                                        value={choice.value}
                                        checked={isChecked}
                                        onBlur={() => {
                                            onBlur && onBlur()
                                        }}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                            if (e.target.checked) {
                                                onChange(choice);
                                            }
                                        }}
                                    />
                                    {choice.text}
                                    {iconMap.hasOwnProperty(choice.value) && <i className={iconMap[choice.value]} />}
                                </label>
                            }
                        </div>
                    )
                })}
            </div>
            {errors && errors.map((error: string, index: number) => (
                <div key={index} className="invalid-feedback">
                    {error}
                </div>
            ))}
        </>
    );
};